// providerLogos.js — Resolve model_id → provider logo URL.
//
// Apolo modelRegistry usa IDs no formato `<provider>/<model>` (e.g.
// "anthropic/claude-opus-4-7", "deepseek/deepseek-chat"). Esse helper
// extrai o provider prefix e devolve a URL do logo correspondente.
//
// Sprint v8.3 — Pedro pediu trocar Bot icon pelo logo da LLM no MessageBubble.

import { ADAPTER_LOGOS } from './adapterLogos.js';

// Provider prefix → adapter name (chave no ADAPTER_LOGOS).
// Multi-LLM core (modelRegistry/chat.js) usa provider names curtos. Adapter
// catalog usa nomes ligeiramente diferentes (anthropic-api vs anthropic).
const PROVIDER_TO_ADAPTER = {
  anthropic: 'anthropic-api',
  openai: 'openai-api',
  google: 'gemini',
  deepseek: 'deepseek',
  openrouter: 'openrouter',
  ollama: 'ollama',
  xai: 'xai',
  mistral: 'mistral',
  groq: 'groq',
  qwen: 'qwen',
  together: 'together',
  kimi: 'kimi',
  zai: 'zai',
  minimax: 'minimax',
  yi: 'yi',
  huggingface: 'huggingface',
};

export function getProviderFromModelId(modelId) {
  if (!modelId || typeof modelId !== 'string') return null;
  const slash = modelId.indexOf('/');
  if (slash < 0) return null;
  return modelId.slice(0, slash).toLowerCase();
}

export function getProviderLogo(modelId) {
  const provider = getProviderFromModelId(modelId);
  if (!provider) return null;
  const adapterName = PROVIDER_TO_ADAPTER[provider] || provider;
  return ADAPTER_LOGOS[adapterName] || null;
}

export function getProviderLabel(modelId) {
  const provider = getProviderFromModelId(modelId);
  if (!provider) return 'Agente';
  const labels = {
    anthropic: 'Claude',
    openai: 'GPT',
    google: 'Gemini',
    deepseek: 'DeepSeek',
    openrouter: 'OpenRouter',
    ollama: 'Ollama',
    xai: 'Grok',
    mistral: 'Mistral',
    groq: 'Groq',
    qwen: 'Qwen',
    together: 'Together',
    kimi: 'Kimi',
    zai: 'GLM',
    minimax: 'MiniMax',
    yi: 'Yi',
    huggingface: 'HF',
  };
  return labels[provider] || provider;
}
